module.exports = __webpack_public_path__ + "img/photo-album-test-04.e21e6943.png";